<script setup lang="ts">
interface Content {
  title?: string
  description?: string
  banner?: string
  mobileBanner?: string
}

interface Props {
  content: Content
}

const props = defineProps<Props>()
</script>

<template>
  <section class="page-banner relative w-full flex flex-col items-center max-ml:hidden">
    <Pic class="w-full relative z-0 min-h-20rem max-ml:w-100% max-ml:object-cover max-ml:object-center"
      :src="props.content.banner" alt="" />
    <PageContentCenter v-if="content.title" class="text-[#616671] absolute top-[136px]">
      <h2 v-if="content.title" class="text-42.08px text-[#102136] mb-[2rem] font-semibold">
        {{ content.title }}
      </h2>
      <p v-if="content.description" class="">{{ content.description }}</p>
    </PageContentCenter>
  </section>
  <section v-if="content.mobileBanner" class="ml:hidden w-full">
    <Pic class="w-full" :src="content.mobileBanner || content.banner"></Pic>
  </section>
</template>

<style lang="scss" scoped>
.page-banner {
  position: relative;
}
</style>
